import { createSlice } from '@reduxjs/toolkit'

export const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    // true
    openPaymentModal: false,
    openBuyQrTyModal: false,
    openSupportModal: false,
  },
  reducers: {
    setOpenPaymentModal: (state, { payload }) => {
      state.openPaymentModal = payload
    },
    setOpenBuyQrTyModal: (state, { payload }) => {
      state.openBuyQrTyModal = payload
    },
    setOpenSupportModal: (state, { payload }) => {
      state.openSupportModal = payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setOpenPaymentModal, setOpenBuyQrTyModal, setOpenSupportModal } =
  modalSlice.actions

export const modalSelector = (state) => state.modal
export const modalReducer = modalSlice.reducer
